var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { isNum, isValid } from '@ecom-zform/shared';
export var setIn = function (pathArray, source, value) {
    var arr = __spreadArray([], __read(pathArray));
    for (var i = 0; i < arr.length; i++) {
        var path = arr[i];
        if (!isValid(source)) {
            return;
        }
        if (!isValid(source[path])) {
            if (!isValid(value)) {
                return;
            }
            if (i < arr.length - 1) {
                source[path] = isNum(arr[i + 1]) ? [] : {};
            }
        }
        if (i === arr.length - 1) {
            source[path] = value;
        }
        else {
            source = source[path];
        }
    }
};
export var getIn = function (pathArray, source) {
    var arr = __spreadArray([], __read(pathArray));
    for (var i = 0; i < arr.length; i++) {
        if (!isValid(source)) {
            return source;
        }
        var path = arr[i];
        if (i === arr.length - 1) {
            return source[path];
        }
        else {
            source = source[path];
        }
    }
    return source;
};
